import React from "react";
import { SUBMISSION_LISTS_EVALUATIONS } from "../../utils/utils";


const OverallEvaluation = ({
 id,
 overall
 }) => {

  return (
    SUBMISSION_LISTS_EVALUATIONS.map((value) => {
      return <i className={`fas fa-star ${value !== 5 ? 'mr-2' : ''} ${overall && overall >= value ? "color-yellow" : "icon-light-gray4"}`}
                id={`overall_evaluation_${value}_for_submission_list_${id}`}
                key={`overall_evaluation_${value}_for_submission_list_${id}`}
      ></i>
    })
  )
}

export default OverallEvaluation;